export default __webpack_public_path__ + "static/media/793.4997c241.png";